import _toConsumableArray from '@babel/runtime-corejs3/helpers/toConsumableArray';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _spliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/splice';
import _indexOfInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/index-of';
import { useEffect } from 'react';
import '../../node_modules/react-dnd/dist/esm/af597232e4287e1eccfc726dc727db9ba15b2b54007e8cfc25e30ca7416d66b5.cfe-internal.js';
import '../../node_modules/react-dnd-html5-backend/dist/esm/bbf6cf49dbb2f98d8f0a51f1f574c80cb3782df09169471707d4a9364d593207.cfe-internal.js';
import '../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import { useDrag } from '../../node_modules/react-dnd/dist/esm/hooks/useDrag/8a7c9dfae1eebb7cfc01ed00c70e8c0457ef28b1822815734a1266bfd5dbc9c3.cfe-internal.js';
import { getEmptyImage } from '../../node_modules/react-dnd-html5-backend/dist/esm/a03ffcd48f5ce123bd4987cf25a280214b9f7b03036781e15b1e385bea286436.cfe-internal.js';
import useLatest from '../../hooks/useLatest/1f51704b192f9e30a9862fa17b105c3f6454cca23cf8d6fb114db55de1c4e301.cfe-internal.js';
import { useDrop } from '../../node_modules/react-dnd/dist/esm/hooks/useDrop/90700e4d466990a211c44b76dcf6f85f8a4aef8ff34e5c8f844526599bb728b9.cfe-internal.js';

var useDragAndDrop = function useDragAndDrop(_ref) {
  var isEnabled = _ref.isEnabled,
    id = _ref.id,
    tableId = _ref.tableId,
    columnIndex = _ref.columnIndex,
    columnHeaderRef = _ref.columnHeaderRef,
    isPinned = _ref.isPinned,
    setPinnedColumns = _ref.setPinnedColumns,
    setColumnOrder = _ref.setColumnOrder,
    setDragSource = _ref.setDragSource,
    setDropTarget = _ref.setDropTarget,
    dropTargetSide = _ref.dropTargetSide,
    setDropTargetSide = _ref.setDropTargetSide;
  var _useDrag = useDrag(function () {
      return {
        type: tableId,
        item: function item() {
          setDragSource(id);
          return {
            id: id,
            isPinned: isPinned,
            columnIndex: columnIndex
          };
        },
        end: function end() {
          setDragSource('');
          setDropTarget('');
          setDropTargetSide(undefined);
        },
        canDrag: function canDrag() {
          return isEnabled;
        },
        options: {
          dropEffect: 'move'
        }
      };
    }, [id, tableId, isPinned, columnIndex, isEnabled, setDragSource, setDropTarget, setDropTargetSide]),
    _useDrag2 = _slicedToArray(_useDrag, 3),
    dragRef = _useDrag2[1],
    dragPreviewRef = _useDrag2[2];

  // Remove HTML5 DnD preview
  useEffect(function () {
    dragPreviewRef(getEmptyImage(), {
      captureDraggingState: false
    });
  }, [dragPreviewRef, id, isPinned, columnIndex]); // id, isPinned, and columnIndex included intentionally

  var dropTargetSideRef = useLatest(dropTargetSide);
  var _useDrop = useDrop(function () {
      return {
        accept: tableId,
        hover: function hover(item, monitor) {
          var _monitor$getClientOff, _columnHeaderRef$curr;
          var dragSourceId = item.id,
            dragSourceColumnIndex = item.columnIndex,
            dragSourceIsPinned = item.isPinned;
          setDropTarget(id);
          if (id === dragSourceId) {
            setDropTargetSide(undefined);
            return;
          }

          // Calculate which column line is closest
          var dropX = (_monitor$getClientOff = monitor.getClientOffset()) === null || _monitor$getClientOff === void 0 ? void 0 : _monitor$getClientOff.x;
          var _ref2 = (_columnHeaderRef$curr = columnHeaderRef.current) === null || _columnHeaderRef$curr === void 0 ? void 0 : _columnHeaderRef$curr.getBoundingClientRect(),
            x = _ref2.x,
            width = _ref2.width;
          var diffLeft = Math.abs(dropX - x) || 0;
          var diffRight = Math.abs(dropX - (x + width)) || 0;
          if (diffLeft < diffRight) {
            // hover over left side
            if (columnIndex - dragSourceColumnIndex === 1 && isPinned === dragSourceIsPinned) {
              setDropTargetSide(undefined);
            } else {
              setDropTargetSide('left');
            }
          } else if (diffLeft >= diffRight) {
            // hover over right side
            if (dragSourceColumnIndex - columnIndex === 1 && isPinned === dragSourceIsPinned) {
              setDropTargetSide(undefined);
            } else {
              setDropTargetSide('right');
            }
          }
        },
        drop: function drop(item) {
          var dragSourceId = item.id,
            dragSourceColumnIndex = item.columnIndex,
            dragSourceIsPinned = item.isPinned;
          if (id === dragSourceId || dropTargetSideRef.current === undefined) {
            return;
          }
          if (isPinned && !dragSourceIsPinned) {
            // Dragging from an unpinned column onto a pinned column
            setPinnedColumns(function (pinnedColumns) {
              var newPinnedColumns = _toConsumableArray(pinnedColumns);
              var newIndex = dropTargetSideRef.current === 'right' ? columnIndex + 1 : columnIndex;
              _spliceInstanceProperty(newPinnedColumns).call(newPinnedColumns, newIndex, 0, dragSourceId);
              return newPinnedColumns;
            });
          } else if (!isPinned && dragSourceIsPinned) {
            // Dragging from a pinned column onto an upinned column
            setPinnedColumns(function (pinnedColumns) {
              var newPinnedColumns = _toConsumableArray(pinnedColumns);
              _spliceInstanceProperty(newPinnedColumns).call(newPinnedColumns, dragSourceColumnIndex, 1);
              return newPinnedColumns;
            });
            setColumnOrder(function (currentColumnOrder) {
              var newColumnOrder = _toConsumableArray(currentColumnOrder);
              var dragSourceColumnOrderIndex = _indexOfInstanceProperty(newColumnOrder).call(newColumnOrder, dragSourceId);
              _spliceInstanceProperty(newColumnOrder).call(newColumnOrder, dragSourceColumnOrderIndex, 1);
              var columnOrderIndex = _indexOfInstanceProperty(newColumnOrder).call(newColumnOrder, id);
              var newIndex = dropTargetSideRef.current === 'right' ? columnOrderIndex + 1 : columnOrderIndex;
              _spliceInstanceProperty(newColumnOrder).call(newColumnOrder, newIndex, 0, dragSourceId);
              return newColumnOrder;
            });
          } else if (isPinned) {
            // Dragging from a pinned column onto a pinned column
            setPinnedColumns(function (pinnedColumns) {
              var newPinnedColumns = _toConsumableArray(pinnedColumns);
              _spliceInstanceProperty(newPinnedColumns).call(newPinnedColumns, dragSourceColumnIndex, 1);
              var newIndex = dropTargetSideRef.current === 'right' ? columnIndex + 1 : columnIndex;
              _spliceInstanceProperty(newPinnedColumns).call(newPinnedColumns, newIndex, 0, dragSourceId);
              return newPinnedColumns;
            });
          } else {
            // Dragging from an upinned column onto an upinned column
            setColumnOrder(function (currentColumnOrder) {
              var newColumnOrder = _toConsumableArray(currentColumnOrder);
              var dropIndex = _indexOfInstanceProperty(newColumnOrder).call(newColumnOrder, dragSourceId);
              _spliceInstanceProperty(newColumnOrder).call(newColumnOrder, dropIndex, 1);
              var columnOrderIndex = _indexOfInstanceProperty(newColumnOrder).call(newColumnOrder, id);
              var newIndex = dropTargetSideRef.current === 'right' ? columnOrderIndex + 1 : columnOrderIndex;
              _spliceInstanceProperty(newColumnOrder).call(newColumnOrder, newIndex, 0, dragSourceId);
              return newColumnOrder;
            });
          }
        },
        canDrop: function canDrop() {
          return isEnabled;
        },
        collect: function collect(monitor) {
          return {
            isOver: monitor.isOver()
          };
        }
      };
    }, [id, tableId, isPinned, columnIndex, isEnabled, setDropTarget, dropTargetSideRef, setDropTargetSide]),
    _useDrop2 = _slicedToArray(_useDrop, 2),
    isOver = _useDrop2[0].isOver,
    dropRef = _useDrop2[1];

  // Clear dropTarget when header is no longer being hovered
  useEffect(function () {
    if (!isOver) {
      setDropTarget(function (currentDropTarget) {
        if (currentDropTarget === id) {
          setDropTargetSide(undefined);
          return '';
        }
        return currentDropTarget;
      });
    }
  }, [id, isOver, setDropTarget, setDropTargetSide]);
  return {
    dragRef: dragRef,
    dropRef: dropRef
  };
};

export { useDragAndDrop as default };
